import { useCallback } from "react";
import ActionMenu from "../ActionMenu";
import Loader from "@builder/components/app/Loading/Loader";

interface SelectItemsProps {
    filteredOptions: string[];
    isActionOpen: boolean;
    setActionOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
    callback: (value: string) => void;
    setIsOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
    isMulti: boolean;
    setSearching: (value: boolean) => void;
    isLoading?: boolean;
}

const SelectItems = ({
    filteredOptions,
    isActionOpen,
    setActionOpen,
    callback,
    setIsOpen,
    isMulti,
    setSearching,
    isLoading=false
}: SelectItemsProps) => {
    const selectOption = useCallback(
        (e: React.MouseEvent) => {
            const value = e.currentTarget.getAttribute("data-value");
            if (value) {
                callback(value);
                setIsOpen(isMulti ? true : false);
                setSearching(false);
            }
        },
        [callback]
    );

    return (
        <>
            {filteredOptions &&
                filteredOptions.map((option, index) => {
                    if (option.toLowerCase() === "trigger action") {
                        return (
                            <ActionMenu
                                key={index}
                                index={index}
                                option={option}
                                selectOption={selectOption}
                                isActionOpen={isActionOpen}
                                setActionOpen={setActionOpen}
                            />
                        );
                    } else {
                        return (
                            <div key={index} className="select-input-option-con" data-value={option} onClick={selectOption}>
                                {option.charAt(0).toUpperCase() + option.slice(1)}
                            </div>
                        );
                    }
                })}
            {filteredOptions && filteredOptions.length === 0 && (
                <div className="select-input-option-con empty">No matches found.</div>
            )}
            {isLoading && filteredOptions && filteredOptions.length > 0 ? (
                <div className="select-input-option-con empty loader">
                    <Loader width="28" height="28" />
                </div>
            ) : null}
        </>
    );
};

export default SelectItems;
